// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"plus"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 7.5V12M12 12L12 16.5M12 12L16.5 12M12 12L7.5 12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PlusIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'plus',
    ref,
    icon: element,
  },
));

PlusIcon.displayName = 'PlusIcon';

export default PlusIcon;
